/* The purpose of this module is to regroup utility functions that are used in both 2d and 3d
timeline analysis modules without creating a dependency between those two modules. */
import h from 'hyperscript';

import type { Color } from '@disy/lib/colors';

import type { Timeline } from 'cadenza/api-client/timeline-api';

import './timeline-utils.css';

export const CREATE_DATE_FILTER_EVENT = 'timeline-player:create-date-filter';
export type DateIntervalOverrideMode = 'START' | 'END';
export interface CREATE_DATE_FILTER_EVENT_PAYLOAD {
  start: Date;
  end: Date;
  overrideMode: DateIntervalOverrideMode;
}

/**
 * Given a timeline-like object (having properties layerName and optionally timelineID),
 * determine the label and tootlip texts.
 *
 * @param timeline - The timeline
 * @return An object with the label and tooltip properties
 */
export function determineTimelineLabelAndTooltip(timeline: Pick<Timeline, 'timelineId' | 'layerName'>) {
  const label = timeline.timelineId || timeline.layerName;
  const tooltip = timeline.timelineId ? `${timeline.layerName} – ${timeline.timelineId}` : timeline.layerName;
  return { label, tooltip };
}

const FALLBACK_TIMELINE_COLOR = '#aaaaaa';

/**
 * Create an HTML element representing a timeline point in the given color.
 *
 * @param timelineColor - Color for the timeline points
 * @param size - The size of the point, as a CSS size value, Default is 0.7em
 * @return An HTML element representing a timeline point in the given color.
 */
export function createTimelinePointSignatureElement(timelineColor?: Color, size?: string) {
  const elmt = h('span.d-timeline-player-point', {
    style: { 'background-color': timelineColor || FALLBACK_TIMELINE_COLOR },
  });
  if (size) {
    elmt.style.height = size;
    elmt.style.width = size;
  }
  return elmt;
}
